import { apiRequest } from './_tools';

export function fetchImpressionsCount({ filter }) {
  return apiRequest('/api/reports/impressions/impressionsCount?' +
    `dateFrom=${filter.date.from}` +
    `&dateTo=${filter.date.to}` +
    `&adType=${filter.adType}` +
    `&publisherId=${filter.publisherId}` +
    `&appId=${filter.appId}` +
    `&countryCode=${filter.countryCode}`)
  .catch(({ error }) => Promise.reject(error));
}

export function fetchImpressionsAllCountries({ filter, sort }) {
  return apiRequest('/api/reports/impressions/impressionsAllCountries?' +
    `dateFrom=${filter.date.from}` +
    `&dateTo=${filter.date.to}` +
    `&publisherId=${filter.publisherId}` +
    `&appId=${filter.appId}` +
    `&adType=${filter.adType}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
  .catch(({ error }) => Promise.reject(error));
}

export function fetchImpressionsAllCampaigns({ filter, sort }) {
  return apiRequest('/api/reports/impressions/impressionsAllCampaigns?' +
    `dateFrom=${filter.date.from}` +
    `&dateTo=${filter.date.to}` +
    `&publisherId=${filter.publisherId}` +
    `&appId=${filter.appId}` +
    `&adType=${filter.adType}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
  .catch(({ error }) => Promise.reject(error));
}

export function fetchImpressionsStatistics({ filter }) {
  return apiRequest('/api/reports/impressions/impressionsStatistics?' +
    `dateFrom=${filter.date.from}` +
    `&dateTo=${filter.date.to}` +
    `&publisherId=${filter.publisherId}` +
    `&appId=${filter.appId}` +
    `&adType=${filter.adType}` +
    `&countryCode=${filter.countryCode}`)
  .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/impressionsReports.js
 **/